
function enableStats() {
}

export default enableStats;
